import { render, staticRenderFns } from "./HistoryPolicyDrawer.vue?vue&type=template&id=4993d8a0&scoped=true"
import script from "./HistoryPolicyDrawer.vue?vue&type=script&lang=js"
export * from "./HistoryPolicyDrawer.vue?vue&type=script&lang=js"
import style0 from "./HistoryPolicyDrawer.vue?vue&type=style&index=0&id=4993d8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993d8a0",
  null
  
)

export default component.exports